<template>
  <div class="card mx-5 my-4" style="width: 16rem;">
    <a
      v-bind:href="url"
      target="_blank"
    >
      <img class="card-img-top" v-bind:src="require(`@/assets/${img}`)" alt="">
    </a>
    <div class="card-body">
      <h5 class="card-title">{{ title }}</h5>
      <p class="card-text">{{ desc }}</p>
      <a
        v-bind:href="url"
        target="_blank"
        class="btn btn-danger"
      >
         Visit Website
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreCard',
  data () {
    return {
    }
  },
  props: ['title', 'desc', 'img', 'url'],
}
</script>




<style scoped>
header h1 {
  font-family: monospace;
  font-weight: normal;
  align-self: center;
}
h5 {
  font-family: serif;
  font-size: 1.5em;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #eee;
}

@import url('https://fonts.googleapis.com/css2?family=Kaushan+Script&display=swap');
</style>



// WEBPACK FOOTER //
// src/components/StoreCard.vue